export default {"src":"/_next/static/media/Arrow-Down-dark.e2b511f9.svg","height":24,"width":24};